import AutoObjCadItem from './CadItem';

/*
* Equipment
*
* new AutoEquipment( 0,1,null,"",0,0,0);
*/
export default class AutoObjExterior extends AutoObjCadItem {
  /* constructor(index: number, cIndex: number, flr: number, p: marietta3d.AutoGen.utils.RoomPoint, item: string, rot: number, wid: number, dep: number) {
    super(index, cIndex, flr, p, item, rot, wid, dep);
  } */
}
